import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-barcode",
  "use": "icon-barcode-usage",
  "viewBox": "0 0 13.12 13.124",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13.12 13.124\" id=\"icon-barcode\">\r\n  <defs>\r\n    <style>\r\n      #icon-barcode .cls-1 {\r\n        fill: #40a9ff;\r\n        fill-rule: evenodd;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"icon-barcode_条形码图片\" class=\"cls-1\" d=\"M1083.5,250.948a6.552,6.552,0,1,0,6.55,6.552A6.549,6.549,0,0,0,1083.5,250.948Zm-2.32,9.97h-1.03v-6.8h1.03v6.8Zm2.05,0h-0.61v-6.8h0.61v6.8Zm3.62,0h-1.38v-6.8h1.38v6.8Z\" transform=\"translate(-1076.94 -250.938)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/barcode.svg
// module id = vxWv
// module chunks = 127